






























































































import Vue from 'vue'
// import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import { ISelectItem } from '@/interfaces'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
// @ts-ignore
import ClickOutside from 'vue-click-outside'
import ScrollView from '@/components/ScrollView.vue'
import { Component, Watch } from 'vue-property-decorator'
// @ts-ignore
import { v4 as uuidv4 } from 'uuid'

@Component({
  components: {
    ScrollView,
    LoaderWrapper,
    Icon
  },
  directives: {
    ClickOutside
  },
  props: {
    error: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    trimLabel: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    closeOutside: {
      type: Boolean,
      default: true
    },
    forceDirection: {
      type: String,
      default: ''
    },
    value: {}
  }
})
export default class SelectV2 extends Vue {
  inputValue: string = ''
  direction: string = 'up'

  lastSelected: ISelectItem | null = null
  selectedIndex: number = 0
  opened: boolean = false
  emitEnterDisable: boolean = false

  key: string = 'select-' + uuidv4()

  get displayOptions () {
    if (!this.$props.options || !this.$props.options.length) {
      return []
    }
    return this.$props.options.filter((item: ISelectItem) => (
      (typeof item.content === 'number' ? item.content : item.content ? item.content : '')
        .toString()
        .toLowerCase()
        .indexOf(this.inputValue.toLowerCase()) !== -1
    ))
  }

  get isSelected () {
    return ![undefined, null, ''].includes(this.$props.value)
  }

  get selectedItem () {
    const propValueToString: string = this.$props.value || ''.toString()
    const propValueIsStringyBool: boolean = propValueToString === 'true' || propValueToString === 'false'
    return this.$props.options.find((item: ISelectItem) => {
      const itemValueToString: string = item.value || ''.toString()
      return (item.value === this.$props.value) ||
        (propValueIsStringyBool && itemValueToString === propValueToString)
    })
  }

  get selectedItemContent () {
    if (this.selectedItem) {
      return this.selectedItem.content
    }

    if (this.$props.placeholder) {
      return this.$props.placeholder
    }

    return ''
  }

  mounted () {
    this.calculateDirection()
  }

  selectItem (item: ISelectItem) {
    this.$emit('input', item.value)
    this.$emit('change', item.value)
    this.lastSelected = item
    setTimeout(() => this.closeList(), 200)
  }

  activate () {
    if (this.$refs.inputField) {
      (this.$refs.inputField as any).focus()
    }
  }

  selectSelectedIndexItem (e: any) {
    if (this.opened) {
      e.preventDefault()
    }

    e.stopPropagation()
    const item = this.displayOptions[this.selectedIndex]
    if (item) {
      this.selectItem(item)
    }

    return false
  }

  changeSelectedIndex (direction: string | null, index: number | null = null) {
    if (!this.opened) {
      return
    }

    if (direction) {
      const alignScroll = () => {
        // @ts-ignore
        const scrollbar: any = this.$refs.scrollbar.$el
        if (!scrollbar) {
          return
        }
        const rect = scrollbar.getBoundingClientRect()
        const listPaddings = 16
        const itemHeight = 38
        const height = rect.height - listPaddings
        const currentPositionTop = this.selectedIndex * itemHeight
        if (currentPositionTop - scrollbar.scrollTop > height - itemHeight && direction === 'down') {
          scrollbar.scrollTop = currentPositionTop - height + itemHeight
        } else if (currentPositionTop < scrollbar.scrollTop && direction === 'up') {
          scrollbar.scrollTop = currentPositionTop - itemHeight
        }
      }
      if (direction === 'up' && this.selectedIndex > 0) {
        this.selectedIndex--
        alignScroll()
      } else if (this.selectedIndex < this.displayOptions.length - 1) {
        this.selectedIndex++
        alignScroll()
      }
      return
    }
    if (index) {
      this.selectedIndex = index
    }
  }

  // positions dropdown fixed
  positionElementFixed () {
    this.calculateDirection()
    // @ts-ignore
    const el = this.$refs.inputField.getBoundingClientRect()
    // @ts-ignore
    const wrapper = this.$refs.scrollbarWrapper.$el
    wrapper.style.position = 'fixed'
    wrapper.style.top = this.direction === 'up'
      ? `${el.top - 240 - 4}px`
      : `${el.top + el.height + 4}px`
    wrapper.style.left = `${el.left}px`
    wrapper.style.width = `${el.width}px`
  }

  handleInput () {
    this.selectedIndex = 0
    this.lastSelected = this.displayOptions.length === 1
      ? this.displayOptions[0]
      : null
  }

  openListWithDelay () {
    setTimeout(this.openList, 150)
  }

  openList () {
    if (this.opened) {
      return
    }
    if (this.$props.appendToBody) {
      this.positionElementFixed()
      document.addEventListener('scroll', this.positionElementFixed)
    }

    if (this.$props.disabled) {
      return
    }

    this.calculateDirection()

    this.inputValue = ''
    this.opened = true
    this.$emit('toggle', true)
    this.$emit('focus', true)

    if (!this.$props.value) {
      return
    }

    const idx: number = this.$props.options.findIndex((x: any) => x.value === this.$props.value)
    this.selectedIndex = idx >= 0 ? idx : 0
    // @ts-ignore
    const scrollbar: any = this.$refs.scrollbar.$el
    if (!scrollbar) {
      return
    }
    const itemHeight = 38
    setTimeout(() => {
      scrollbar.scrollTop = this.selectedIndex * itemHeight
    }, 50)
  }

  closeOutSide () {
    if (!this.$props.closeOutside) {
      return
    }
    this.closeList()
  }

  closeList () {
    if (this.$props.appendToBody) {
      document.removeEventListener('scroll', this.positionElementFixed)
    }
    this.opened = false
    this.$emit('toggle', false)
    this.$emit('focusout')
  }

  closeListWithDelay () {
    setTimeout(() => this.closeList(), 200)
  }

  clear () {
    if (this.$props.disabled) {
      return
    }
    this.$emit('input', '')
  }

  calculateDirection () {
    if (this.$props.forceDirection) {
      this.direction = 'up'
      return
    }
    const blockHeight = 40
    const maxBarHeight = 210
    const boxHeight = Math.min(maxBarHeight + blockHeight, blockHeight + this.$props.options.length * 30)
    const rect = (this.$refs.myElement as any).getBoundingClientRect()
    this.direction = rect.y + boxHeight > window.innerHeight ? 'up' : 'down'
  }

  @Watch('displayOptions')
  rerenderScrollOnChange () {
    this.key = 'select-' + uuidv4()
  }
}
